/**
 * Vorberechnete Indexstrukturen des 9x9-Gitters.
 * Zellen sind zeilenweise von 0..80 durchnummeriert.
 */

export const ROW_OF = new Uint8Array(81);
export const COL_OF = new Uint8Array(81);
export const BOX_OF = new Uint8Array(81);

for (let i = 0; i < 81; i++) {
  const r = Math.floor(i / 9);
  const c = i % 9;
  ROW_OF[i] = r;
  COL_OF[i] = c;
  BOX_OF[i] = Math.floor(r / 3) * 3 + Math.floor(c / 3);
}

/** Die 27 Einheiten: 9 Zeilen, 9 Spalten, 9 Blöcke – je 9 Zellindizes. */
export const ROWS: Uint8Array[] = [];
export const COLS: Uint8Array[] = [];
export const BOXES: Uint8Array[] = [];

for (let u = 0; u < 9; u++) {
  ROWS.push(new Uint8Array(9));
  COLS.push(new Uint8Array(9));
  BOXES.push(new Uint8Array(9));
}
{
  const fill = new Uint8Array(27);
  for (let i = 0; i < 81; i++) {
    const r = ROW_OF[i];
    const c = COL_OF[i];
    const b = BOX_OF[i];
    ROWS[r][fill[r]++] = i;
    COLS[c][fill[9 + c]++] = i;
    BOXES[b][fill[18 + b]++] = i;
  }
}

export const UNITS: Uint8Array[] = [...ROWS, ...COLS, ...BOXES];

/** Die drei Einheiten (Zeile, Spalte, Block), zu denen eine Zelle gehört. */
export const UNITS_OF: Uint8Array[][] = [];
for (let i = 0; i < 81; i++) {
  UNITS_OF.push([ROWS[ROW_OF[i]], COLS[COL_OF[i]], BOXES[BOX_OF[i]]]);
}

/** Die 20 Nachbarzellen (gleiche Zeile, Spalte oder Block), ohne die Zelle selbst. */
export const PEERS: Uint8Array[] = [];
for (let i = 0; i < 81; i++) {
  const set = new Set<number>();
  for (const unit of UNITS_OF[i]) for (const j of unit) if (j !== i) set.add(j);
  PEERS.push(Uint8Array.from(set));
}

/** Zellen eines Blocks, die in der angegebenen Zeile/Spalte liegen. */
export function indexOf(row: number, col: number): number {
  return row * 9 + col;
}
